import { Settings } from "./types";

export const settings = Settings.parse({
    maxWidth: 1200, origin: process.env.REACT_APP_ORIGIN, apiUrl: `${process.env.REACT_APP_ORIGIN}${process.env.REACT_APP_API_PATH}`,
});
